import { useState, useEffect } from "react";
import HttpService from "../../services/HttpService";

export default function EditTurnaround() {
   const [statuses, setStatuses] = useState([]);
   const [editedValues, setEditedValues] = useState({});
   const [saving, setSaving] = useState({});


   useEffect(() => {
      const fetchStatus = async () => {
         try {
            const res = await HttpService.get(`Turnaround/GetTurnaround`);
            setStatuses(res);
         } catch (error) {
            console.error('Error fetching status data:', error);
         }
      }

      fetchStatus();
   }, [])

   const handleChange = (status, newvalue) => {
      setEditedValues(prev => ({
         ...prev, [status]: newvalue,
      }));
   }

   const handleUpdate = async (status) => {
      const newTurnaround = editedValues[status];

      setSaving(prev => ({ ...prev, [status]: true }));

      try {
         await HttpService.post(`Turnaround/UpdateTurnaround?status=${status}&turnaround=${newTurnaround}`);

         setStatuses(prev => 
            prev.map(item => item.status === status ? { ...item, turnaroundtime: newTurnaround } : item)
         );
         setEditedValues(prev => {
            const updated = { ...prev };
            delete updated[status];
            return updated;
         });

         setSaving(prev => {
            const updated = { ...prev };
            delete updated[status];
            return updated;
         });
      } catch (error) {
         console.error('Error updating turnaround:', error);

         // Stop saving even if error
         setSaving(prev => {
            const updated = { ...prev };
            delete updated[status];
            return updated;
         });
      }
   }

   return ( 
      <div className="edit-status-list space-y-4">
         <h3 className="text-2xl font-bold">Edit Estimated Turnaround Times</h3>
         <p>Displayed below is the current estimated turnaround times for each status displayed to Brokers, to update/change a turn around time enter a new value in the field and click 'Update'.</p>
         <hr />
         {statuses.map(item => {
            const currentValue = editedValues[item.status] ?? item.turnaroundtime ?? '';
            const hasChanged = String(currentValue) !== String(item.turnaroundtime ?? '');
            const isSaving = !!saving[item.status];

            return (
               <div key={item.status} className="edit-status flex items-center gap-3">
                  <label htmlFor={`${item.status}-value`} className="w-48 font-medium">
                  {item.status}
                  </label>

                  <input
                  id={`${item.status}-value`}
                  type="number"
                  value={currentValue}
                  onChange={e => handleChange(item.status, e.target.value)}
                  className="border rounded px-2 py-1 w-12"
                  disabled={isSaving}
                  />

                  {isSaving ? (
                     <span className="text-gray-500 text-sm">Saving...</span>
                  ) : (
                     hasChanged && (
                        <button
                           onClick={() => handleUpdate(item.status)}
                           className="btn primary-btn sml-btn py-0.5 px-1 ml-2"
                           disabled={isSaving}
                        >
                           Update
                        </button>
                     )
                  )}
               </div>
            );
         })}
      </div>
   );
}